<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <!--            <el-form-item label="会员ID" prop="memberId">-->
            <!--                <el-input v-model="dataForm.memberId" placeholder="会员ID"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="现金余额增加数量" prop="cashBalanceAdd">
                <el-input-number v-model="dataForm.cashBalanceAdd" placeholder="现金余额"></el-input-number>
            </el-form-item>
            <el-form-item label="优果余额增加数量" prop="integrationBalanceAdd">
                <el-input-number v-model="dataForm.integrationBalanceAdd" placeholder="优果余额"></el-input-number>
            </el-form-item>
            <el-form-item label="注册优果余额增加数量" prop="integrationDeviceAdd">
                <el-input-number v-model="dataForm.integrationDeviceAdd" placeholder="锁定现金"></el-input-number>
            </el-form-item>
            <el-form-item label="分红优果余额增加数量" prop="integrationShareAdd">
                <el-input-number v-model="dataForm.integrationShareAdd" placeholder="分红优果余额增加数量"></el-input-number>
            </el-form-item>
            <!--            <el-form-item label="锁定优果" prop="integrationLock">-->
            <!--                <el-input v-model="dataForm.integrationLock" placeholder="锁定优果"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="银行名称" prop="bankName">-->
            <!--                <el-input v-model="dataForm.bankName" placeholder="银行名称"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="银行开户名" prop="bankAccountName">-->
            <!--                <el-input v-model="dataForm.bankAccountName" placeholder="银行开户名"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="银行卡号" prop="bankCardNumber">-->
            <!--                <el-input v-model="dataForm.bankCardNumber" placeholder="银行卡号"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="更新时间" prop="updateDate">-->
            <!--                <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>-->
            <!--            </el-form-item>-->
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    integrationDevice: '', integrationDeviceAdd: '',
                    memberId: '',
                    cashBalance: '', cashBalanceAdd: '',
                    integrationBalance: '', integrationBalanceAdd: '',
                    integrationShareAdd:'',
                    cashLock: '',
                    integrationLock: '',
                    bankName: '',
                    bankAccountName: '',
                    bankCardNumber: '',
                    createDate: '',
                    updateDate: ''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    cashBalanceAdd: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    integrationBalanceAdd: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    integrationShareAdd: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    cashLock: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    integrationLock: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    bankName: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    bankAccountName: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    bankCardNumber: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    updateDate: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/ums/memberbalance/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/ums/memberbalance/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
